<style scoped>
@import url("../assets/css/detail.css");
</style>

<template>
  <div>
    <div class="page-loading" v-show="!show">
      <div class="loading-content">
        <img src="../assets/images/page_loading.gif">
        <p class="title">正在加载...</p>
      </div>
    </div>
    <div class="detail-home common-home-content" v-show="show">
      <div class="section2 ice_bg section-bor-bom">
        <h2>智慧诊断</h2>
        <div class="p-content pr">
          <p v-if="locData.diagnosis">{{ locData.diagnosis }}</p>
          <p v-else>暂无诊断结果</p>
        </div>
      </div>
      <div class="section1 ice_bg" v-if="locData.cause">
        <h2>分析</h2>
        <div class="p-content pr">
          <p class="symptoms_panel" data-key="symptoms">
            {{ locData.cause }}
          </p>
        </div>
      </div>
      <div class="recommend-content ice_bg mt5" v-if="doctorData.length>0">
        <div class="mb15 clearfix">
          <h2 class="mtt-h2 fl">医生推荐</h2>
        </div>
        <div v-for="(item,index) in doctorData" :key="index" class="doctor-content" @click="toAskDoctor(item.id)">
          <div class="avatar">
            <img :src="item.avatar" v-if="item.avatar" alt="头像"/>
            <img src="../assets/images/default_doctor.png" v-else alt="头像"/>
          </div>
          <p class="name-studio-price"><span class="name">{{ item.name }}</span>
          </p>
          <p class="title-department">{{ item.title }} {{ item.department }}</p>
          <p class="skill">{{ item.skill }}</p>
          <p class="diagnose-favorable"><span class="item">接诊率：{{ item.diagnose_rate }}</span><span
              class="item">好评率：{{ item.favorable_rate }}</span><span class="item">咨询量：{{ item.diagnosed_count }}</span>
          </p>
          <p class="tags">
            <span class="tag gold-medal" v-if="item.tags[0]">{{ item.tags[0] }}</span>
            <span class="tag response" v-if="item.tags[1]">{{ item.tags[1] }}</span>
          </p>

        </div>
      </div>
      <div class="section1 ice_bg mt5" v-if="locData.cheng || locData.fang">
        <h2>诊疗建议</h2>
        <div class="p-content pr" v-if="locData.cheng">
          <p class="sub_title">【中成药】</p>
          <div class="pr icon-composition">
            <span class="br-t-l ice_bg"></span>
            <span class="br-t-r ice_bg"></span>
            <span class="br-b-l ice_bg"></span>
            <span class="br-b-r ice_bg"></span>
            <p class="copy_composition products_name">{{ locData.cheng }}</p>
          </div>

          <div v-if="recommendData.type == 3">
            <p class="sub_title pr mt10">【中药方】
              <!--                          <span class="recommend-medicine-buy" @click="toBuyMedicine(recommendData.info)">去购买</span>-->
            </p>
            <div class="pr icon-composition">
              <span class="br-t-l ice_bg"></span>
              <span class="br-t-r ice_bg"></span>
              <span class="br-b-l ice_bg"></span>
              <span class="br-b-r ice_bg"></span>
              <p class="copy_composition" data-key="prescription">{{ recommendData.info.name }}：<span
                  v-for="(medicine,index) in recommendData.info.content"
                  :key="index">{{ medicine.name }}{{ medicine.quantity }}{{ unitFormat(medicine.unit) }} </span></p>
            </div>
          </div>
        </div>
      </div>
      <div class="section ice_bg mt5" v-if="locData.anli">
        <div class="mb15 clearfix">
          <h2 class="mtt-h2 fl" v-if="locData.anli.head">{{ locData.anli.head }}</h2>
          <h2 class="mtt-h2 fl" v-else>参考病例</h2>
        </div>
        <div class="mtc">
          <p class="mc-anli-p1 fb">{{ locData.anli.anname }}</p>
          <p class="mc-anli-p2">
            <span class="fb mr10 name">{{ locData.anli.doc_name }}</span>{{ locData.anli.title }} <span
              v-if="locData.anli.zhi">{{ locData.anli.zhi }}</span><span
              v-if="locData.anli.section">（{{ locData.anli.section }}）</span>
          <p class="mc-anli-text" v-for="(child,index) in locData.anli.text" :key="index">{{ child }}</p>
          <!-- <p class="mc-anli-text">……</p> -->
        </div>
      </div>
      <div class="section ice_bg mt5" v-if="locData.jiu">
        <div class="mb15 clearfix">
          <h2 class="mtt-h2 fl" v-if="locData.jiu.head">{{ locData.jiu.head }}</h2>
          <h2 class="mtt-h2 fl" v-else>针灸治疗</h2>
        </div>
        <div class="mtc">
          <p class="mc-anli-p1 fb">{{ locData.jiu.anname }}</p>
          <p class="mc-anli-p2">
            <span class="fb mr10 name">{{ locData.jiu.doc_name }}</span>{{ locData.jiu.title }} <span class="ml5"
                                                                                                      v-if="locData.jiu.zhi">{{
              locData.jiu.zhi
            }}</span><span
              v-if="locData.jiu.section">（{{ locData.jiu.section }}）</span>
          <p class="mc-anli-text" v-for="(child,index) in locData.jiu.text" :key="index">{{ child }}</p>
          <!-- <p class="mc-anli-text">……</p> -->
        </div>
      </div>
      <div class="section ice_bg mt5" v-if="locData.nature">
        <div class="mb15 clearfix">
          <h2 class="mtt-h2 fl" v-if="locData.nature.head">{{ locData.nature.head }}</h2>
          <h2 class="mtt-h2 fl" v-else>自然疗法</h2>
        </div>
        <div class="mtc">
          <p class="mc-anli-p1 fb">{{ locData.nature.name }}</p>
          <p class="mc-anli-text" v-for="(child,index) in locData.nature.text" :key="index">{{ child }}</p>
          <!-- <p class="mc-anli-text">……</p> -->
        </div>
      </div>

      <!--      <div class="recommend-content ice_bg mt5" v-if="jigouData.length>0">-->
      <!--        <div class="mb15 clearfix">-->
      <!--          <h2 class="mtt-h2 fl">机构推荐</h2>-->
      <!--          <p class="mtt-p" @click="toAskJigou(false,false,'other')">更多 <img style="width: 16px;height: 16px"-->
      <!--                                                              src='../assets/images/dstree/back.png' alt=""></p>-->
      <!--        </div>-->
      <!--        <div v-for="(item,index) in jigouData" :key="index" class="doctor-content" @click="toAskJigou(item.id,item.store_type,'')">-->
      <!--          <div class="avatar">-->
      <!--            <img :src="item.avatar" v-if="item.avatar" alt="头像"/>-->
      <!--            <img src="../assets/images/default_doctor.png" v-else alt="头像"/>-->
      <!--          </div>-->
      <!--          <p class="name-studio-price"><span class="name">{{ item.title }}</span>-->
      <!--          </p>-->

      <!--          <p class="tags">-->
      <!--            <span class="tag gold-medal" v-if="item.tags[0]">{{ item.tags[0] }}</span>-->
      <!--            <span class="tag response" v-if="item.tags[1]">{{ item.tags[1] }}</span>-->
      <!--          </p>-->
      <!--          <p class="title-department">{{ item.address }}</p>-->

      <!--        </div>-->
      <!--      </div>-->
      <!--      <div style=" background: #fff; margin-bottom: 20px;padding: 10px; box-sizing: border-box;">-->
      <!--        <div style=" padding: 10px;box-sizing: border-box;border-radius: 15px;background: #E6F6E9;">-->
      <!--          <p style=" padding-bottom: 4px;color: #578F4E;">参考引源：</p>-->
      <!--          <p style="color: #4E894F; word-break: break-word">-->
      <!--            我们的测试，所涉及的医疗、养生内容均由神黄中医智库联合中医专家审校通过后发布。相关测试量表内容已先在微信公众号(id:zk120com)或头条号(id:神黄中医智库)上审核发布。https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzAxOTIzMTc1NA==&action=getalbum&album_id=2877305962636967940#wechat_redirect</p>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--            <div class="recommend-content ice_bg mt5" v-if="recommendData.type == 4">-->
      <!--                <p class="title">推荐好物</p>-->
      <!--                <div class="resource-content">-->
      <!--                    <div class="picture">-->
      <!--                        <img :src="recommendData.info.img_url" alt="图片" />-->
      <!--                    </div>-->
      <!--                    <p class="name">{{recommendData.info.title}}</p>-->
      <!--                    <p class="summary">{{recommendData.info.introduce}}</p>-->
      <!--                    <p class="price" :class="recommendData.info.line_price > 0?'price-margin':''" v-html="priceFormat2(recommendData.info.price)"></p>-->
      <!--                    <p class="line_price" v-if="recommendData.info.line_price"><span class="through" v-html="priceFormat2(recommendData.info.line_price)"></span></p>-->
      <!--                    <div class="buy" @click="toMiniProgram(recommendData.type, recommendData.info.good_alias)">立即购买</div>-->
      <!--                </div>-->
      <!--            </div>-->
      <div class="btns-content clearfix">
        <button class="left fl" :class="!free_doctor_show?'long':''" @click="pageback()">重新自测</button>
        <!--                <button class="right fr" v-show="free_doctor_show" @click="toAskDoctor(false)">免费问医生</button>-->
      </div>
    </div>
  </div>
</template>

<script>
import http from '../assets/api/friggApiConfig'
import http2 from '../assets/api/hermerApiConfig'
import http3 from '../assets/api/dorisApiConfig'
import http4 from '../assets/api/iapetusApiConfig'
// import http5 from '../assets/api/zkApiConfig'
import doctor_show from '../assets/api/doctorApiConfig'
import h5_url from '../assets/api/h5ApiConfig'
import {deviceType} from "../utils/deviceType";
import familyBaUrl from "../assets/api/familyBaApiConfig";

export default {
  data() {
    return {
      locData: {},
      recommendData: {},
      detailId: null,
      free_doctor_show: 0,
      show: false,
      doctorData: [],
      jigouData: [],
      isIOS: deviceType.isIOSApp,
      isApp: 'H5',
      cityName: '',
      lat: '',
      lng: '',
    };
  },
  created() {
    let bridge = window.WebViewJavascriptBridge;
    this.detailId = this.$route.params.detail_id;
    this.free_doctor_show = doctor_show;
    this.loadinit();
    this.$appUtils.appCloseLoadingView();
    window.appBack = () => this.pageback();
    // let bridge = window.WebViewJavascriptBridge;
    this.isApp = this.$appUtils.isApp();
    if (this.isApp == "IOS") {
      bridge.callHandler('getAddress', '', (res) => {
        this.cityName = res.city
        this.lat = res.lat
        this.lng = res.lng
      })
    }
  },
  methods: {
    unitFormat(unit) {
      if (unit == '克') {
        return 'g';
      }
      return unit;
    },
    priceFormat(price) {
      price = (price * 100 / 100).toFixed(2);
      price = price.split('.');
      return '<span style="font-size: 12px;">￥</span>' + price[0] + '.' + '<span style="font-size: 12px;">' + price[1] + '起</span>';
    },
    priceFormat2(price) {
      price = (price / 100).toFixed(2);
      price = price.split('.');
      return '<span style="font-size: 12px;">￥</span>' + price[0] + '.' + '<span style="font-size: 12px;">' + price[1] + '起</span>';
    },
    getRecommendData() {
      var that = this;
      var param = {"type": 2}
      http2.get("/goods/recommend", {params: param}).then(function (res) {
        that.recommendData = res.data.data;
      });
    },
    toBuyMedicine(item) {
      let that = this;
      if (that.$appUtils.appIsLogin()) {
        let params = {
          prescription_name: item.name
        }
        http3.get("/drugs/prescription/info", {params: params}).then(function (res) {
          if (res.data.status_code == 200) {
            let obj = {
              name: item.name,
              content: item.content,
              price: res.data.data.price,
              num: 1
            }
            window.location.href = h5_url + "/medicineorder?t=1&obj=" + JSON.stringify(obj);
          } else {
            that.$layer.msg(res.data.msg);
          }
        });
      }
    },
    toMiniProgram(type, id) {
      this.$appUtils.appOpenMiniProgram({"type": type, "id": id});
    },
    toAskDoctor(id) {

      let bridge = window.WebViewJavascriptBridge;
      this.isApp = this.$appUtils.isApp();
      if (this.isApp == "IOS") {
        if (id) {
          bridge.callHandler("toAskDoctor", {"page_type": "doctor_detail", "doctor_id": id}, (response) => {
            console.log(response);
          })
        } else {
          bridge.callHandler("toAskDoctor", {
            "page_type": "doctor_list",
            'key_word': this.locData.cases
          }, (response) => {
            console.log(response);
          })
        }
      } else if (this.isApp == "android") {
        if (id) {
          this.$appUtils.appAskDoctor({"page_type": "doctor_detail", "doctor_id": id});
        } else {
          this.$appUtils.appAskDoctor({"page_type": "doctor_list", 'key_word': this.locData.cases});
        }
      } else {
        console.log(familyBaUrl + '/doctorDetail?id=' + id)
        window.location.href = familyBaUrl + '/doctorDetail?id=' + id
      }
    },
    toAskJigou(id, type, name) {
      let bridge = window.WebViewJavascriptBridge;
      this.isApp = this.$appUtils.isApp();
      if (this.isApp == "IOS") {
        if (id) {
          bridge.callHandler("institutionInfoClick", {"hospital_id": id, 'store_type': type}, (response) => {
            console.log(response);
          })
        } else {
          bridge.callHandler("moreInstitutionClick", {name: name}, (response) => {
            console.log(response);
          })
        }
      } else if (this.isApp == "android") {
        if (id) {
          this.$appUtils.appAskDoctorSeeking({"hospital_id": id, 'store_type': type});//单独进入详情
        } else {
          this.$appUtils.appAskDoctorSeeking({'store_type': 0, name: name});//进入更多
        }
      }
    },
    loadinit() {
      var that = this;
      http.get("/zhen/goods/solution/" + that.detailId).then(function (res) {
        that.locData = res.data.answer;
        that.show = true;
        let params = {
          page: 1,
          page_size: 20,
          keywords: that.locData.cases,
          studio_id: 7,
        }
        // let params1 = {
        //   page: 1,
        //   page_size: 20,
        //   keywords: that.locData.cases,
        //   cityName: that.cityName,
        //   lat: that.lat,
        //   lng: that.lng,
        // }
        http4.get('doctors', {params: params}).then(res => {
          if (res.data.status_code == 200) {
            that.doctorData = res.data.data.doctors
          }
        })
        // http5.get('hospital/recommend', {params: params1}).then(res => {
        //   if (res.data.status_code == 200) {
        //     that.jigouData = res.data.data
        //     console.log(that.jigouData);
        //   }
        // })
      });
    },
    pageback() {
      //this.$router.push({ path: "/"});
      window.history.go(-2);
      return true;
    }
  }
}
</script>

